import type { ColorOption } from '../types/config'

interface ColorSelectorProps {
  colors: ColorOption[]
  selectedId: string
  onSelect: (id: string) => void
  label?: string
}

export function ColorSelector({ colors, selectedId, onSelect, label }: ColorSelectorProps) {
  return (
    <div className="space-y-3">
      {label && (
        <label className="block text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <div className="flex flex-wrap gap-4 justify-center">
        {colors.map((color) => (
          <button
            key={color.id}
            onClick={() => onSelect(color.id)}
            className="flex flex-col items-center gap-2 group"
            type="button"
          >
            <div
              className={`
                w-12 h-12 rounded-full transition-all duration-200
                ${selectedId === color.id 
                  ? 'ring-2 ring-offset-2 ring-exness-dark scale-110' 
                  : 'border border-gray-300 hover:scale-105 hover:shadow-lg'
                }
              `}
              style={{ backgroundColor: color.hex }}
              title={color.name}
            />
            <span 
              className={`
                text-xs font-medium transition-colors
                ${selectedId === color.id ? 'text-exness-dark' : 'text-gray-500 group-hover:text-gray-700'}
              `}
            >
              {color.name}
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}
